export default "__VITE_ASSET__5b102179__"